import { writable } from 'svelte/store';

export const createGuiDimensionsStore = () => writable({ w: 0, h: 0 });

let gds = createGuiDimensionsStore();
export const guiDimensionsStore = gds;
